/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S10_P2_PostInputs */

const tr_iade_iptal_s10_p2_post = /** @type {(inputs: Iade_Iptal_S10_P2_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` adresine iletilir. Önceden kabul edilmiş sözleşmelerdeki erişim ve dışa aktarma hakları saklıdır.`)
};

const en_iade_iptal_s10_p2_post = /** @type {(inputs: Iade_Iptal_S10_P2_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Access and export rights under previously accepted contracts remain valid.`)
};

const de_iade_iptal_s10_p2_post = /** @type {(inputs: Iade_Iptal_S10_P2_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Zugriffs- und Exportansprüche aus bereits angenommenen Vertragsfassungen bleiben bestehen.`)
};

const ru_iade_iptal_s10_p2_post = /** @type {(inputs: Iade_Iptal_S10_P2_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Права на доступ и экспорт по ранее принятым договорам сохраняются.`)
};

/**
* | output |
* | --- |
* | ". Access and export rights under previously accepted contracts remain valid." |
*
* @param {Iade_Iptal_S10_P2_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s10_p2_post = /** @type {((inputs?: Iade_Iptal_S10_P2_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S10_P2_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s10_p2_post(inputs)
	if (locale === "de") return de_iade_iptal_s10_p2_post(inputs)
	if (locale === "ru") return ru_iade_iptal_s10_p2_post(inputs)
	return tr_iade_iptal_s10_p2_post(inputs)
});